import { useMemo } from 'react'

import { Badge } from 'antd'
import { hasUnreadMessages } from '../../utils/entities/chatRoom'

const BLUE = 'rgb(60, 141, 188)'

const ShiftMessagingDot = ({ shift, status }) => {
  const color = useMemo(() => {
    let color = 'grey'

    if (shift && shift.chatRooms && shift.chatRooms.length > 0) {
      color = hasUnreadMessages(shift.chatRooms[0]) ? 'red' : BLUE
    } else if (status === 1) {
      color = BLUE
    } else if (status === 2) {
      color = 'red'
    }

    return color
  })

  return (
    <div style={{ position: 'absolute', top: '-8px', left: 'calc(100% - 4px)' }}>
      <Badge color={color} />
    </div>
  )
}

export default ShiftMessagingDot
